// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".open-effect[data-v-649517bf]{background-color:#178aff;line-height:16px;color:#fff;padding:8px;border-radius:4px;-webkit-animation:open-data-v-649517bf 1.5s linear infinite;animation:open-data-v-649517bf 1.5s linear infinite}@-webkit-keyframes open-data-v-649517bf{0%{color:#fff}50%{color:#178aff}to{color:#fff}}@keyframes open-data-v-649517bf{0%{color:#fff}50%{color:#178aff}to{color:#fff}}", ""]);
// Exports
module.exports = exports;
